import api from "../api";

export const useUpdateSteps = (data) =>
  api.put(`/user/guide-step?step=${data}`, ).then((res) => res.data);
